import { PROPOSTA_SITUACAO } from "@repo/core/services/entities/Proposals";
import { ROUTES } from "@repo/core/routes";
import { normalizeProposalSituationCode } from "./analysisQueueRules";

export const CREDIT_TABLE_POST_SAVE_ACTION = "sendToCreditTable" as const;

export const isCreditAnalysisProcessingStatus = (
  statusCode: string | number | undefined | null
): boolean => {
  const normalized = normalizeProposalSituationCode(statusCode);

  return (
    normalized === PROPOSTA_SITUACAO.QUEUE_ANALYSIS_AUTOMATIC ||
    normalized === PROPOSTA_SITUACAO.WAITING_FOR_ANALYSIS ||
    normalized === PROPOSTA_SITUACAO.ANALYSIS_AUTOMATIC
  );
};

export const shouldCompleteCreditProposalBeforeCreditTable = (
  statusCode: string | number | undefined | null
): boolean =>
  normalizeProposalSituationCode(statusCode) ===
  PROPOSTA_SITUACAO.PRE_PROPOSAL_REJECTED;

export const getCreditTableEntryNavigation = (
  statusCode: string | number | undefined | null,
  proposalId: string
) => {
  if (shouldCompleteCreditProposalBeforeCreditTable(statusCode)) {
    return {
      route: ROUTES.creditProposalPersonalData,
      params: { proposalId },
      postSaveAction: CREDIT_TABLE_POST_SAVE_ACTION
    };
  }

  return {
    route: ROUTES.sendCreditTable,
    params: { proposalId },
    postSaveAction: undefined
  };
};

export const getCreditProposalPostSaveNavigation = (
  postSaveAction: string | undefined,
  proposalId: string | number | undefined
) => ({
  route:
    postSaveAction === CREDIT_TABLE_POST_SAVE_ACTION
      ? ROUTES.sendCreditTable
      : ROUTES.proposalsViewInfo,
  params: { proposalId }
});
